import {
  Stack,
  Typography,
  Container,
  Grid,
  Paper,
  Box,
  Button,
  TextField,
} from "@mui/material";
import { useContext, useEffect, useState, useRef } from "react";
import { UserContext } from "../../contexts/userContext";
import { getUserCertificates, updateUserFirstLastName } from "../../facades/UserFacade";
import dayjs from "dayjs";
import { getUnixTime } from "date-fns";
import { Helmet } from "react-helmet-async";
import ReactToPrint from "react-to-print";

const Certificate = ({ certificate }) => {
  const contentRef = useRef(null);

  return (
    <>
      <Paper
        sx={{
          backgroundImage: `url('${certificate.background}')`,
          height: 550,
          width: 740,
          backgroundSize: "cover",
          marginLeft: "auto",
          marginRight: "auto",
        }}
        id={certificate.id}
        ref={contentRef}
      >
        <Box sx={{ height: "100%" }}>
          <Stack
            sx={{ height: "100%" }}
            direction="column"
            alignItems="center"
            justifyContent="center"
          >
            <div
              dangerouslySetInnerHTML={{
                __html: certificate.content,
              }}
            />
          </Stack>
        </Box>
      </Paper>
      <ReactToPrint
        trigger={() => {
          return <Button variant="text">Print</Button>;
        }}
        content={() => contentRef.current}
        documentTitle="new document"
        pagestyle="print"
      />
    </>
  );
};

const UserDetailsUpdateForm = ({userDetailsChangedCallback}) => {

    const userContext = useContext(UserContext);
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");

    const updateUserDetails = () => {
        if(!firstName || !lastName){
            return;
        }   
        updateUserFirstLastName(userContext.user, firstName, lastName)
        .then((res) => {
            if(res.ok){
                userDetailsChangedCallback();
            }
        })
    }

    //return a row of 2 text fields for first name and last name with a save button
    return <Box>
        <Typography variant="h6">Update your details</Typography>
        <Stack direction="row" spacing={2} alignItems="center">
            <TextField  placeholder="First Name" value={firstName} onChange={(e)=> setFirstName(e.target.value)}/>
            <TextField  placeholder="Last Name" value={lastName} onChange={(e) => setLastName(e.target.value)}/>
            <Button variant="contained" onClick={() => updateUserDetails()}>Save</Button>
        </Stack>
    </Box>
    
}
export default function MyCertificates({}) {
  const userContext = useContext(UserContext);
  const [certificates, setCertificates] = useState([]);
 // const certificateRefs = useRef(new Array());

  useEffect(() => {
    getUserCertificates(userContext.user).then((res) => setCertificates(res));
  }, []);

  const getNiceDate = (unixtime) => {
    let day = dayjs.unix(unixtime);
    return day.format("dddd D MMMM YYYY");
  };

  
  const userDetailsChangedCallback = () => {
    getUserCertificates(userContext.user).then((res) => setCertificates(res));
  }
  let userDetailsUpdateForm = null;

  if(certificates.length != 0) {
        if(certificates[0].name.trim() == "") {
            userDetailsUpdateForm = <UserDetailsUpdateForm userDetailsChangedCallback={userDetailsChangedCallback}/>;
        }
  }
  return (
    <Container maxWidth="xl">
      <Helmet>
        <title>My Results - KnowledgEquity</title>
      </Helmet>
      <Grid sx={{ padding: "20px" }}>
        <Typography sx={{ p: 1 }} variant="h5">
          My Certificates
        </Typography>
        
        <Stack alignItems="center" spacing={2}>
        {userDetailsUpdateForm}
          {certificates.map((certificate) => {
           // console.log(certificate);
            //const getRef = (element) => certificateRefs.current.push(element);
            return <Certificate certificate={certificate} key={certificate.id}/>;
          })}
        </Stack>
      </Grid>
    </Container>
  );
}
